import {Component, OnInit, Input, SimpleChanges, OnChanges} from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from '@tdo-inc/ngx-gallery/projects/gallery/src';
import { FileManagerService } from '../../../../file-manager/file-manager.service';
import { DocumentDataModel } from '../../../../../models/document/document-data.model';
import {DocumentInFolderDataModel} from '../../../../../models/document/document-in-folder-data.model';

@Component({
  selector: 'app-io-view-gallery',
  templateUrl: './io-view-gallery.component.html',
  styleUrls: ['./io-view-gallery.component.css']
})
export class IoViewGalleryComponent implements OnInit, OnChanges {
  @Input() dataset: DocumentInFolderDataModel[] = [];
  
  galleryOptions: NgxGalleryOptions[] = [];
  galleryImages: NgxGalleryImage[] = [];
  isLoaded = false;
  images: DocumentDataModel[] = [];

  constructor(private fileService: FileManagerService) { }

  ngOnInit() {
    this.galleryOptions = [
      {
        imageSize: 'contain',
        width: '100%',
        height: '100%',
        thumbnailsColumns: 4,
        imageAnimation: 'slide',
        preview: false,
        imageSwipe: true,
        thumbnailsSwipe: true,
        previewSwipe: true
      },
    ];
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.dataset) {
      this.images = this.dataset.map(p => p.dataDocument);
      await this.init();
    }
  }

  async init(): Promise<void> {
    this.galleryImages = [];

    const promises: Promise<any>[] = [];
    const results: string[] = [];
    this.images.forEach(o => {
      // promises.push(this.fileService.getDocumentUrlFromDocument(o).toPromise());
      results.push(this.fileService.getDocumentUrlFromDocument(o));
    });

    results.forEach(o => this.galleryImages.push({
      small: o,
      medium: o,
      big: o
    }));

    /*try {
      const results: string[] = await Promise.all(promises);

      results.forEach(o => this.galleryImages.push({
        small: o,
        medium: o,
        big: o
      }));
    }
    catch (error) {
      console.log(error);
    }*/
  }

  onDataLoaded($event: Event) {
    this.isLoaded = true;
    console.log(this.galleryImages);
  }
}
